import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { TablePagination } from "@material-ui/core";
import { getDailyTaskRewards } from "../../store/dailyTaskReward/action";
import DailyTaskRewardDialog from "../dialog/DailyTaskRewardDialog";

const TablePaginationActions = React.lazy(() => import("./TablePagination"));

const DailyTaskRewards = ({ getDailyTaskRewards }) => {
  const tasks = useSelector((state) => state.dailyTaskReward.tasks);
  const [data, setData] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getDailyTaskRewards();
  }, []);

  useEffect(() => {
    setData(tasks);
  }, [tasks]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    const value = event.target.value.trim().toUpperCase();
    if (!value) return setData(tasks);

    setPage(0);
    setData(
      tasks.filter(
        (task) =>
          task.title?.toUpperCase().includes(value) ||
          task.description?.toUpperCase().includes(value) ||
          task.key?.toUpperCase().includes(value),
      ),
    );
  };

  const targetLabel = (task) => {
    if (task.unit === "second") {
      const minutes = Math.floor(task.target / 60);
      if (minutes >= 60 && minutes % 60 === 0) {
        const hours = minutes / 60;
        return `${hours} hour${hours > 1 ? "s" : ""}`;
      }
      return `${minutes} minutes`;
    }
    return `${task.target} ${task.unit}${task.target > 1 ? "s" : ""}`;
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left"></div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mt-lg-0 mt-xl-0">
                  <form action="">
                    <div className="input-group mb-3 border rounded-pill">
                      <div className="input-group-prepend border-0">
                        <div id="button-addon4" className="btn text-danger">
                          <i className="fas fa-search mt-2"></i>
                        </div>
                      </div>
                      <input
                        type="search"
                        placeholder="What're you searching for?"
                        aria-describedby="button-addon4"
                        className="form-control bg-none border-0 rounded-pill searchBar"
                        onChange={handleSearch}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>
              <table className="table table-striped">
                <thead className="text-white">
                  <tr>
                    <th>Task</th>
                    <th>Target</th>
                    <th>Points</th>
                    <th>Version</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data.length ? (
                    (rowsPerPage > 0
                      ? data.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : data
                    ).map((task) => (
                      <tr key={task._id}>
                        <td>
                          <div className="text-white font-weight-bold">
                            {task.title}
                          </div>
                          <small className="text-muted">
                            {task.description}
                          </small>
                        </td>
                        <td>
                          <div>{targetLabel(task)}</div>
                          {task.minRoomUsers > 1 && (
                            <span
                              className="badge bg-info mt-1"
                              title="Progress only counts while the room holds this many users, and is saved when it pauses."
                            >
                              Needs {task.minRoomUsers}+ in room
                            </span>
                          )}
                        </td>
                        <td>
                          {task.configured ? task.points : <span className="text-warning">Inactive</span>}
                        </td>
                        <td>{task.rewardVersion || 0}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => setSelectedTask(task)}
                          >
                            <i className="fas fa-edit" />{" "}
                            <span className="icon_margin">Configure</span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <TablePagination
                id="pagination"
                component="div"
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  100,
                  { label: "All", value: -1 },
                ]}
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </div>
          </div>
        </div>
      </div>
      {selectedTask && (
        <DailyTaskRewardDialog
          task={selectedTask}
          onClose={() => setSelectedTask(null)}
        />
      )}
    </>
  );
};

export default connect(null, { getDailyTaskRewards })(DailyTaskRewards);
